import type { QueryClient } from "@tanstack/react-query";
import {
  getAppointmentsQueryKey,
  getBonusesQueryKey,
  getClientQueryKey,
  getClubsQueryKey,
  getPurchaseHistoryQueryKey,
  getSwimmersDiaryQueryKey,
  getTicketsQueryKey,
  getVisitsHistoryQueryKey,
} from "@/utils/queryKeys";

const clientScopedQueryKeys = [
  getClientQueryKey,
  getClubsQueryKey,
  getAppointmentsQueryKey,
  getTicketsQueryKey,
  getPurchaseHistoryQueryKey,
  getBonusesQueryKey,
  getVisitsHistoryQueryKey,
  getSwimmersDiaryQueryKey,
];

export const invalidateClientScopedQueries = (queryClient: QueryClient) => {
  return Promise.all(
    clientScopedQueryKeys.map((getQueryKey) =>
      queryClient.invalidateQueries({ queryKey: getQueryKey() })
    )
  );
};
